import { render, staticRenderFns } from "./TicketPromedioProducto.vue?vue&type=template&id=54911f62"
import script from "./TicketPromedioProducto.vue?vue&type=script&lang=js"
export * from "./TicketPromedioProducto.vue?vue&type=script&lang=js"
import style0 from "./TicketPromedioProducto.vue?vue&type=style&index=0&id=54911f62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports